import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from '@src/core/services';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly ngxPermissionsService = inject(NgxPermissionsService);
  private readonly userService = inject(UserService);

  readonly allowCreating$ = new BehaviorSubject(false);
  readonly allowEditing$ = new BehaviorSubject(false);
  readonly allowDeleting$ = new BehaviorSubject(false);

  private readonly permissions = this.ngxPermissionsService.getPermissions();

  constructor() {
    this.userService.authUser$.subscribe(user => {
      if (!user) {
        return;
      }

      this.getPermissions();
    });
  }

  getPermissions() {
    this.allowCreating$.next('pageCreating' in this.permissions);

    this.allowEditing$.next('pageEditing' in this.permissions);

    this.allowDeleting$.next('pageDeleting' in this.permissions);
  }
}
